import axios from '@/utils/axios'
import {AddressValues} from '@/forms/Address'

export const GetWishlist = async ({queryKey}: any) => {
  const {data} = await axios.get(process.env.NEXT_PUBLIC_API_URL + '/wishlist/')

  return data
}

export const WishlistDelete = async (id: number) => {
  const {data} = await axios.delete(
    process.env.NEXT_PUBLIC_API_URL + '/wishlist/' + id,
  )

  return data
}

export const WishlistAdd = async (id: number) => {
  const {data} = await axios.post(
    process.env.NEXT_PUBLIC_API_URL + '/wishlist/' + id,
  )

  return data
}

export const CheckInWishlist = async ({queryKey}: any) => {
  const {data} = await axios.get(
    process.env.NEXT_PUBLIC_API_URL +
      '/wishlist/check_in_wishlist/' +
      queryKey[1],
  )

  return data
}
